<template>
    <div class="add-tag-modal-wrapper">
        <TitleBaseBox :title="data.title" @close="close" @confirm="confirmHandle">
            <el-form :rules="rules" :model="formModal" ref="ruleForm" label-width="100px">
                <el-form-item label="标签分类" prop="currentClassId">
                    <el-select v-model="formModal.currentClassId" filterable placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签名称" prop="name">
                    <el-input v-model="formModal.name" placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="标签说明">
                    <el-input v-model="formModal.describe" placeholder="请输入备注" />
                    <span class="note-txt">注: hover标签时显示相应说明备注</span>
                </el-form-item>
                <el-form-item label="参数条件" prop="groups">
                    <div class="add-param-group-wrapper">
                        <!-- 条件组 -->
                        <div class="param-group-content">
                            <!-- 指标组 -->
                            <ConditionGroup
                                v-model="formModal.groups[0].conditions"
                                :widget="condWidgetConfig"
                                :validation="myValidation"
                                class="group-param"
                            />
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </TitleBaseBox>
    </div>
</template>
<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import ConditionGroup from "@/views/zhiji/components/commonForm/widgets/conditionGroup/index.vue";
import Validation from "@/views/zhiji/components/commonForm/validation.js";
import { getOperateList, getConditionLVList, getConditionNodeDetail, addTag, editTag, queryTagClassList } from "../server";

export default {
    name: "TagModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        ConditionGroup
    },
    data() {
        return {
            typesOperators: [],
            params: [],
            elseGroupId: "",
            formModal: {
                currentClassId: this.data.classId,
                name: this.data.name,
                describe: this.data.describe,
                groups: [{ conditions: null }]
            },
            options: [], // 标签分类下拉项
            // 校验规则
            rules: {
                currentClassId: [{ required: true, message: "请选择标签分类", trigger: "blur" }],
                name: [{ required: true, message: "请输入标签名称", trigger: "blur" }]
            },
            groupNameWidget: {
                props: {
                    placeholder: "判断条件名称，如：当XXX时"
                }
            },
            groupNameRules: [{ required: true }],
            // 条件逻辑数据
            condWidgetConfig: {
                props: {
                    conditionParams: {
                        getParamConfig: () => {
                            return this.params;
                            // 传递这种数据格式当options
                            // return [
                            //     { label: "测试", value: { valType: "datetime", value: "测试", options: { label: "测试", value: "test" } } },
                            //     { label: "测试2", value: { valType: "string", value: "测试2", options: { label: "测试2", value: "test2" } } }
                            // ];
                        },
                        getOptions: param => {
                            const typeConfig = this.typesOperators.find(item => item.type.some(tItem => tItem === param.valType));
                            return typeConfig.operators.map(item => ({
                                label: item.name,
                                value: item.op
                            }));
                        },
                        getValueType({ valType, options }, op) {
                            if (valType === "option") {
                                return {
                                    type: valType,
                                    props: {
                                        options
                                    }
                                };
                            } else if (valType === "datetime") {
                                // 时间选择器
                                if (op === "bet" || op === "nbet") {
                                    // 时间段选择器
                                    return { type: "datetimerange" };
                                }
                                return { type: "time" };
                            }
                            return { type: valType, placeholder: "多个值用英文逗号隔开，如张三,李四..." };
                        }
                    },
                    maxLevel: 2, // 嵌套层数
                    fixedConnector: 'AND',
                }
            },
            myValidation: null
        };
    },
    computed: {
        gameId() {
            return this.$store.state.zhiji.gameState.gameId;
        },
    },
    async created() {
        // 创建验证对象
        this.myValidation = new Validation();
        // 操作符
        this.typesOperators = await getOperateList({ gameId: this.gameId });
        // 获取标签分类
        this.getOptions();
        // 获取参数
        this.params = await getConditionLVList(this.gameId);
        await this.getNodeDetail(this.params);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    methods: {
        async getNodeDetail(params) {
            if (this.data.paramJson) {
                // 有初始值
                const { groups } = await getConditionNodeDetail(this.data.paramJson, params);
                this.formModal.groups = groups;
            } else {
                // 无初始值
                this.formModal.groups = [{ updateState: "add", groupName: "", conditions: null }];
            }
        },
        async confirmHandle() {
            // 提交
            await this.validateForm(); // 验证表单
            await this.validateGroups(); // 自定义验证
            const data = {
                gameId: this.gameId,
                name: this.formModal.name,
                classifyId: this.formModal.currentClassId,
                describe: this.formModal.describe,
                paramJson: this.formModal.groups[0].conditions.children,
            };
            if (this.data.id !== undefined) {
                // 编辑
                data.id = this.data.id;
                await editTag(data)
            } else {
                await addTag(data);
            }
            this.data.submit && this.data.submit();
            this.close();
        },
        close() {
            this.$emit("closeModal");
        },
        async validateGroups() {
            const { isValid } = await this.myValidation.validate();
            if (!isValid) {
                throw Error("group校验失败");
            }
        },
        validateForm() {
            return new Promise((resolve, reject) => {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        resolve(true);
                    } else {
                        reject(valid);
                    }
                });
            });
        },
        async getOptions() {
            const { list } = await queryTagClassList({
                gameId: this.gameId,
            });
            this.options = list.map(item => ({
                label: item.name,
                value: item.id.toString(),
            }))
        }
    }
};
</script>
<style scoped lang="less">
.add-tag-modal-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .title-base-mask {
        // width: 545px;
    }
    .el-form-item {
        margin-bottom: 20px;
        .el-form-item {
            padding-right: 30px;
        }
        .el-input {
            width: 480px;
        }
        .note-txt {
            color: #666666;
            margin-left: 12px;
        }
    }
    .add-param-group-wrapper {
        .param-group-content {
            position: relative;
            box-sizing: border-box;
            background: #fbfcfd;
            border: 1px solid #d8e4f0;
            border-radius: 4px;
            padding: 20px 16px;
            margin-bottom: 8px;
            width: 730px;
            .group-param {
                width: 640px;
                /deep/.el-date-editor {
                    width: 280px;
                }
            }
        }
    }
}
</style>
